export default __webpack_public_path__ + "static/radovi9-eabee4f0031248370a2f7ece58aecb1b.jpeg";